// --- START OF FILE RedefinirEmail.js ---

import React, { useEffect, useState, useContext } from "react";
import * as S from './RedefinirEmailStyle';
import axios from "axios";
import Loading from "../Loader";
import { AuthContext } from "../../Context/AuthContext";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BASE = process.env.REACT_APP_API_BASE_URL;

export default function RedefinirEmail() {
    const { getClients, clientsDataBase, authState, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const [nomeCliente, setNomeCliente] = useState("");
    const [selected, setSelected] = useState(null);
    const [pass, setPass] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [load, setLoad] = useState(false);

    // useEffect(() => {
    //     if (
    //       authState.permission !== "ALL" &&
    //       !authState.permission.includes("REDEFINIR LOGIN") 
    //     ) {
    //       navigate("/");
    //     }
    // }, [authState, navigate]);

    const fetchClients = async () => {
        if (!nomeCliente) {
            alert("Por favor, digite um nome para pesquisar.");
            return;
        }
        setLoad(true);
        try {
            // --- LINHA CORRIGIDA ---
            // A ordem dos parâmetros foi restaurada para a versão original e funcional.
            await getClients(50, 0, nomeCliente, "asc", ""); 
        } catch (e) {
            console.error("Erro ao buscar clientes:", e);
        } finally {
            setLoad(false);
        }
    };

    const resetForm = () => {
        setNomeCliente("");
        setSelected(null);
        setPass("");
        setConfirmPass("");
    };

    const handleRedefinir = async () => {
        if (!pass || !confirmPass) {
            alert("Por favor, preencha a nova senha e a confirmação.");
            return;
        }
        if (pass !== confirmPass) {
            alert("As senhas não coincidem!");
            return;
        }
        if (pass.length < 6) {
            alert("A senha deve ter no mínimo 6 caracteres.");
            return;
        }

        setLoad(true);
        const payload = {
            email: selected.email,
            newPassword: pass
        };

        try {
            const headers = { headers: { Authorization: `Bearer ${authState.accessToken}` } };
            await axios.post(`${BASE}client/admin-reset-password`, payload, headers);
            
            alert("Credenciais do cliente redefinidas com sucesso.");
            resetForm();

        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                alert("Sessão Expirada. Por favor, faça login novamente.");
                logout();
            } else {
                const errorMessage = error.response?.data?.message || error.message;
                alert(`Ocorreu um erro: ${errorMessage}`);
            }
        } finally {
            setLoad(false);
        }
    };

    const handleSelectClient = (client) => {
        setSelected(client);
    };

    return (
        <S.ContainerRedefinirSenha>
            <Loading load={load} />
            <S.ImageBackground src="/logo-golden-ouro.png" alt="Golden Token Background" />
            <S.ContentBox>
                <S.Header>
                    <h2>Redefinir Login do Cliente</h2>
                </S.Header>

                <S.Step>
                    <p>Passo 1: Pesquise e selecione o cliente</p>
                    <S.SearchBox>
                        <div className="inputBoxSearch">
                            <input
                                type="text"
                                value={nomeCliente}
                                placeholder="Digite o nome do cliente para pesquisar..."
                                onChange={(e) => setNomeCliente(e.target.value)}
                                onKeyPress={e => e.key === 'Enter' && fetchClients()}
                            />
                            <button onClick={fetchClients} disabled={load}><FaSearch/></button>
                        </div>
                        <S.SearchedClients>
                            <div className="columns">
                                <span>NOME</span>
                                <span>CPF/CNPJ</span>
                                <span>EMAIL</span>
                            </div>
                            {selected ? (
                                <div className="rowSelected">
                                    <span>{selected.name}</span>
                                    <span>{selected.cpfCnpj}</span>
                                    <span>{selected.email}</span>
                                    <button onClick={() => setSelected(null)}><FaTimes/></button>
                                </div>
                            ) : (
                                <div className="tabelona">
                                    {clientsDataBase.map((client) => (
                                        <div onClick={() => handleSelectClient(client)} className="row" key={client.id}>
                                            <span>{client.name}</span>
                                            <span>{client.cpfCnpj}</span>
                                            <span>{client.email}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </S.SearchedClients>
                    </S.SearchBox>
                </S.Step>

                {selected && (
                    <S.Step>
                        <p>Passo 2: Defina a nova senha</p>
                        <S.SelectedContainer>
                            <S.BoxInfo>
                                <label>E-mail do Cliente (Alvo)</label>
                                <input type="email" value={selected.email || ""} readOnly />
                            </S.BoxInfo>
                            <S.BoxInfo>
                                <label>Nova Senha</label>
                                <input type="password" value={pass} onChange={(e) => setPass(e.target.value)} placeholder="Mínimo de 6 caracteres" />
                            </S.BoxInfo>
                            <S.BoxInfo>
                                <label>Confirme a Nova Senha</label>
                                <input type="password" value={confirmPass} onChange={(e) => setConfirmPass(e.target.value)} />
                            </S.BoxInfo>
                            <S.RedefineButton onClick={handleRedefinir} disabled={load}>
                                {load ? "Redefinindo..." : "Redefinir Credenciais"}
                            </S.RedefineButton>
                        </S.SelectedContainer>
                    </S.Step>
                )}
            </S.ContentBox>
        </S.ContainerRedefinirSenha>
    );
}